import { create, w } from '@dojo/framework/core/vdom';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { ChartBase } from './base-chart';
import { ChartProperties } from '../interfaces';

const factory = create({}).properties<ChartProperties>();

export const BarChart = factory(({ properties }) => {
	const {
		ariaLabel = 'bar chart',
		size,
		data,
		drawComplete,
		legend,
		options,
		plugins,
		pluginCode,
		title,
		alternateText
	} = properties();
	const type = 'bar';

	return w(ChartBase, {
		ariaLabel,
		alternateText,
		size,
		data,
		drawComplete,
		legend,
		options,
		plugins,
		pluginCode,
		title,
		type
	});
});
